import CartItem from '@/classes/CartObject';

class AddonCartItem extends CartItem {
  type = 'ADDON';

  lid = null;

  title = null;

  constructor() {
    super();
    return true;
  }
}

export default AddonCartItem;



// WEBPACK FOOTER //
// ./src/classes/AddonCartItem.js